import { render, staticRenderFns } from "./Pph_paid.vue?vue&type=template&id=6c8361fe&scoped=true"
import script from "./Pph_paid.vue?vue&type=script&lang=js"
export * from "./Pph_paid.vue?vue&type=script&lang=js"
import style0 from "./Pph_paid.vue?vue&type=style&index=0&id=6c8361fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8361fe",
  null
  
)

export default component.exports